module.exports = __webpack_public_path__ + "static/img/wgo.bca095f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/wgo.png
// module id = /Si3
// module chunks = 0